import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';

@Component({
  selector: 'app-tdo-configuration-action-bar', 
  templateUrl: './tdo-configuration-action-bar.component.html',
  styleUrls: ['./tdo-configuration-action-bar.component.css']
}) 
export class TdoConfigurationActionBarComponent implements OnInit {
  @Input() saveDisabled: boolean = false;
  @Input() saveHidden: boolean = false;
  @Input() newHidden: boolean = false;
  @Input() showAdd: boolean = false;
  @Input() showCancel: boolean = false;
  @Input() showSave: boolean = true;
  @Input() showEdit: boolean = false;
  @Input() isCustom: boolean = false;
  @Input() showClear: boolean = false; // Default is false (hidden)


  @Output() newClick = new EventEmitter();
  @Output() saveClick = new EventEmitter();
  @Output() addClick = new EventEmitter();
  @Output() cancelClick = new EventEmitter();
  @Output() editClick = new EventEmitter();
  @Output() clearClick = new EventEmitter();


  constructor() { }

  newDisabled: boolean = false;

  ngOnInit(): void {
  }

  onNew(event) {
    //this.showCancel=true;
    //this.newDissabled= true;
    this.newClick.emit(event);
  }

  onSave(event) {
    //this.showCancel=false;
    this.saveClick.emit(event);
  }

  onCancel(event) {
    //this.showCancel=false;
    this.cancelClick.emit(event);
  }

  onAdd(event) {
    //this.showCancel=true;
    this.addClick.emit(event);
  }

  onEdit(event) {
    //this.showCancel=true;
    this.editClick.emit(event);
  }

  onClear(event) {
    this.clearClick.emit(event);
  }
  
}
